import EMOJI_REGEX from 'emojibase-regex/emoji';
import { jsPDF } from 'jspdf';

import { CuripodText } from '../../components/SlideComponents/slateUtil';
import { Alignment } from './renderTextElement';
import { renderLink, renderUnderLine, setPdfTextStyling } from './renderUtils';

const getEmojiImageData = async (emoji: string) => {
  const codePoint = emoji.codePointAt(0);
  const hexCode = codePoint?.toString(16);
  const x = await fetch(
    `https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/${hexCode}.png`,
  );
  if (!x) return null;
  return x.status === 200 ? (await x.blob()).arrayBuffer() : null;
};

type RenderParagraphLineProps = {
  pdf: jsPDF;
  paraLine: CuripodText[];
  x: number;
  y: number;
  width: number;
  alignment: Alignment;
  scale: number;
};

const renderParagraphLine = async ({
  pdf,
  x,
  y,
  width,
  paraLine,
  alignment,
}: RenderParagraphLineProps) => {
  // console.log('paraLine', paraLine);
  let currentX = x;
  let currentY = y;
  let allWordsWidth = 0;

  for (const eachWord of paraLine) {
    setPdfTextStyling({
      pdf,
      color: eachWord.color || '#000',
      bold: !!eachWord.bold,
      italic: !!eachWord.italic,
    });
    const wordWidth = pdf.getTextDimensions(eachWord.text).w;
    allWordsWidth = allWordsWidth + wordWidth;
  }

  switch (alignment.toLowerCase()) {
    case 'right':
      currentX = x + width - allWordsWidth;
      break;
    case 'center':
      currentX = x + width / 2 - allWordsWidth / 2;
      break;
    default:
      currentX = x;
      break;
  }

  for (const eachWord of paraLine) {
    pdf.saveGraphicsState();
    setPdfTextStyling({
      pdf,
      color: eachWord.color || '#000',
      bold: !!eachWord.bold,
      italic: !!eachWord.italic,
    });
    const wordWidth = pdf.getTextDimensions(eachWord.text).w;
    if (eachWord.underline || eachWord.link) {
      renderUnderLine({
        pdf,
        x: currentX,
        y: currentY + pdf.getTextDimensions(eachWord.text).h,
        width: wordWidth,
      });
    }
    if (eachWord.link) {
      renderLink({
        pdf,
        x: currentX,
        y: currentY,
        width: wordWidth,
        height: pdf.getTextDimensions(eachWord.text).h,
        url: eachWord.link,
      });
    }

    for (const eachChar of eachWord.text) {
      const charWidth = pdf.getTextDimensions(eachChar).w;
      const charHeight = pdf.getTextDimensions(eachChar).h;
      const emojiExecResult = EMOJI_REGEX.exec(eachChar);
      if (emojiExecResult?.[0]) {
        const emojiImageData = await getEmojiImageData(emojiExecResult[0]);
        if (emojiImageData) {
          pdf.addImage(
            new Uint8Array(emojiImageData),
            currentX,
            currentY,
            charWidth,
            charHeight,
            undefined,
            'FAST',
          );
          //
        } else pdf.rect(currentX, currentY, charWidth, charHeight);
      } else {
        pdf.text(eachChar, currentX, currentY + pdf.getTextDimensions(eachChar).h);
      }
      currentX = currentX + charWidth;
    }

    pdf.restoreGraphicsState();
  }

  currentY = currentY + pdf.getLineHeight();

  return { updatedX: currentX, updatedY: currentY };
};

export default renderParagraphLine;
